import { zodResolver } from "@hookform/resolvers/zod";

import { ChevronDownIcon, Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { type DayFormDto, createDayDtoSchema } from "slde-api/dto-schemas";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
import { pl } from "react-day-picker/locale";
import { DateFormField } from "@/components/date.form-field";

interface DayFormProps {
  defaultValues?: DayFormDto;
  onSubmit: (values: DayFormDto) => void;

  disabled?: boolean;
  loading?: boolean;
}
export function DayForm({
  onSubmit: onSubmitProps,
  defaultValues,
  disabled,
  loading,
}: DayFormProps) {
  const form = useForm<DayFormDto>({
    resolver: zodResolver(createDayDtoSchema),
    defaultValues,
  });

  function onSubmit(values: DayFormDto) {
    onSubmitProps(values);
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 2xl:grid-cols-3">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <div className="space-y-4">
            <DateFormField control={form.control} name="date" />
          </div>
          <Button type="submit" disabled={disabled || loading}>
            {!!defaultValues ? "Edytuj" : "Dodaj"}
            {loading && <Loader2 className="animate-spin" />}
          </Button>
        </form>
      </Form>
    </div>
  );
}
